import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-table';

const QuestionTable = props => {
    const cols = [
        {
            name: 'item',
            label: 'Item',
        },
        {
            name: 'question',
            label: 'Question',
        },
    ];

    const getData = () => {
        const d = [];
        for (var item of props.items) {
            const { question } = window.cccisd.appDefs.wfiQuestions[`${props.type}_${item}`];
            d.push({ item, question });
        }
        return d;
    };

    return (
        <Table
            rowKey="item"
            columns={cols}
            data={getData()}
            isCsvDownload
            showPerPageOptions={false}
        />
    );
};

QuestionTable.propTypes = {
    type: PropTypes.string,
    items: PropTypes.array,
};

export default QuestionTable;
